<template>
  <div
    type="button"
    class="absolute right-4 top-1/2 -translate-y-1/2 transform cursor-pointer"
    @click="onClickToggleShow"
  >
    <inline-svg :src="icon" width="20" height="22" loading="lazy" alt="eye-icon" />
  </div>
</template>

<script setup>
import { useAsset } from '~/composables/asset'
import InlineSvg from 'vue-inline-svg'

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
})

const isVisible = ref(false)

const icon = computed(() => {
  return useAsset(`icons/base/${isVisible.value ? 'eye' : 'eye-close'}.svg`)
})

const onClickToggleShow = () => {
  toggleShowPassword()
  isVisible.value = !isVisible.value
}

const toggleShowPassword = () => {
  const passwordInput = document.getElementById(props.name)

  if (passwordInput) {
    passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password'
  } else {
    console.error(`Element with ID "${props.name}" not found.`)
  }
}
</script>
